<main class="main-container">
    <div class="big-container">
        <h1 class="logo">STESAJ</h1>
        <div class="title-container">
            <h2 class="main-title">Soporte tecnológico educativo de simulación en administración de justicia</h2>
            <div class="gold-box"></div>
            <div class="white-box"></div>
        </div>
        <footer class="footer">
            <ul>
                <li class="link">Este es un prototipo desarrollado por el laboratorio LiiD</li>
                <li class="link link-end">UTPL {{ currentYear }}</li>
            </ul>
        </footer>
    </div>
    <div class="small-container">
        <div class="form-container">
            <div class="container">
                <button class="btn-back yellow" (click)="volverInicio()">
                    <mat-icon class="icon-back">arrow_back_ios</mat-icon>
                </button>
                <h2 class="title">Iniciar Sesión</h2>
            </div>


            <form class="form" autocomplete="off">

                <div class="form-field">
                    <label for="mail" class="label">Correo Electrónico</label>
                    <input id="mail" type="email" name="email" [(ngModel)]="email">
                </div>
                <div class="form-field">
                    <label for="password" class="label">Contraseña</label>
                    <input id="password" type="password" name="password" [(ngModel)]="password">
                </div>

                <p class="forgot-password">¿Olvidaste tu contraseña? Contacto a liid_utpl@utpl.edu.ec </p>
                <div class="login">
                    <button mat-button (click)="login()" class="btn-login">Continuar</button>
                    <button mat-button routerLink="/register" class="btn-login">Registrarse</button>
                </div>

                <div class="btn-sesion">
                    <p>Ya tienes una cuenta UTPL, inicia sesion aquí</p>
                    <button mat-button (click)="loginUtpl()" class="btn-submit">Iniciar Sesion UTPL</button>
                </div>

            </form>
        </div>
    </div>
</main>
